import { Service, ServiceFormat, AdditionalService } from 'entities/services';
import { StationCategory } from 'entities/stations';
import { Country } from 'entities/countries';
import { CountryBrands } from 'entities/brands';
import { RoadsideService } from 'entities/roadsideServices';
import { DimensionLimitation } from 'entities/dimensions';
import { PaymentType } from 'entities/payments';
import { StatusLoading } from 'common/constants/statusLoading';

export const STATE = "DIRECTORIES";

export interface IState {
  isLoading?: StatusLoading;
  countries: Country[];
  roadsideService: RoadsideService[];
  stationCategories: StationCategory[];
  serviceFormats: ServiceFormat[];
  additionalParams: DimensionLimitation[];
  additionalServices: AdditionalService[];
  services: Service[];
  countriesBrands?: { countries: CountryBrands[]; };
  paymentTypes: PaymentType[];
};